export default __webpack_public_path__ + "static/media/12-32-28 2.b5fea032.jpg";